"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationType = exports.Device = exports.NETWORK = void 0;
var NETWORK;
(function (NETWORK) {
    NETWORK["SOLANA"] = "SOLANA";
    NETWORK["NEAR"] = "NEAR";
})(NETWORK = exports.NETWORK || (exports.NETWORK = {}));
var Device;
(function (Device) {
    Device["Apple"] = "Apple";
    Device["Android"] = "Android";
})(Device = exports.Device || (exports.Device = {}));
// TODO: Create intefaces for all Notifications Types
var NotificationType;
(function (NotificationType) {
    NotificationType["NIGHTLY_CONNECT_REQUEST"] = "NIGHTLY_CONNECT_REQUEST";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
